export enum Unit {
  CubicMeter = 'm³',
  KilowattHour = 'kWh',
  Gigajoule = 'GJ',
  Euro = '€',
}

export const productUnits: { [key: string]: Unit } = {
  gas: Unit.CubicMeter,
  electricity: Unit.KilowattHour,
  redelivery: Unit.KilowattHour,
  warmth: Unit.Gigajoule,
  currency: Unit.Euro,
  tapWater: Unit.Gigajoule,
} as const;
